import React, { useCallback } from 'react'
import { useNavigate, useMatches } from 'react-router-dom'
import { usePath } from '@/hooks'
import {
  MenuPage,
  Main,
  SideMenu,
  Breadcrumbs,
  BreadcrumbsItem,
} from './components'
import Menu from './menu'
import { Home } from '@/icon'

export interface MenuProps {
  children: React.ReactElement;
}

const MenuView: React.FC<MenuProps> = ({ children }) => {
  const { root, path } = usePath()
  console.log('root-------------', root)
  const navigate = useNavigate()
  const matches = useMatches()

  const toPath = useCallback(
    (path: string) => () => {
      navigate(path)
    },
    [navigate]
  )

  const breadcrumbs = () => {
    const crumbs = matches
      .filter((match) => Boolean(match?.handle))
      ?.map((match) => ({
        pathname: match.pathname,
        //@ts-ignore
        name: match.handle?.crumb,
      }))

    return crumbs?.map((crumb) => (
      <BreadcrumbsItem
        key={`breadcrumb-${crumb?.name}`}
        // @ts-ignore
        sx={{ color: location.pathname === crumb.pathname && 'inherit' }}
        onClick={toPath(crumb?.pathname)}
      >
        <span style={{ margin: '0 4px' }}>/</span>
        {crumb?.name}
      </BreadcrumbsItem>
    ))
  }

  return (
    <MenuPage>
      <SideMenu>
        <Menu root={root} path={path} />
      </SideMenu>
      <Main>
        <Breadcrumbs>
          <Home />
          {breadcrumbs()}
        </Breadcrumbs>
        {children}
      </Main>
    </MenuPage>
  )
}

export default MenuView
